import {
	Pipe,
	PipeTransform,
} from '@angular/core';

import { CommonNAFormatter } from './na_formatter.pipe';
import { commonUtilitiesCoreService } from '../services/core.service';

@Pipe({
	name: 'commonPrettyPhoneNumber',
})
export class CommonPrettyPhoneNumber implements PipeTransform {
	constructor (
		private commonNAFormatter: CommonNAFormatter,
	) { }
	transform (
		value: string,
		options: { divider: string; parenthesis: {left: string; right: string} } = { divider: '-', parenthesis: {left: '-', right: '-' }}
	): string {
		if (!commonUtilitiesCoreService.hasValue(value)) {
			return this.commonNAFormatter.transform(value);
		}

		const { divider, parenthesis } = options;
		const prefixRe = /^\+/;
		const phoneRe = /(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/;
		const phoneMatches = phoneRe.exec(value);
		const prefix = prefixRe.test(value) ? '+' : (phoneMatches && phoneMatches[1] === '7' ? '+' : '');

		if (phoneRe.test(value)) {
			return value.replace(
				/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
				`${ prefix }$1${ parenthesis.left }$2${ parenthesis.right }$3${ divider }$4${ divider }$5`,
			);
		}

		return value;
	}
}
